import { memo } from 'react'
import MultipleInputSkeleton from 'components/SkeletonView/MultipleInputSkeleton'

const PayoutAccountSkeleton = () => <MultipleInputSkeleton count={3} />

export default memo(PayoutAccountSkeleton)
